export default "__VITE_ASSET__DxL2nskA__"